import React from "react";
import { HashRouter, Route } from "react-router-dom";

import LandingPage from "./Components/LandingPage";
import VideoUploadPage from "./Components/VideoUploadPage";
import Contact from "./Components/Contact";
import ApproveVideos from "./Components/VideoReview";

import "./App.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
  }

  render() {
    if (this.state.hasError && window.AUTH_TOKEN) {
      return <pre>{this.state.error}</pre>;
    }
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <HashRouter>
        <Route exact path="/" component={LandingPage}></Route>
        <Route exact path="/contact" component={Contact}></Route>
        <Route exact path="/upload" component={VideoUploadPage}></Route>
        <Route exact path="/approve" component={ApproveVideos}></Route>
      </HashRouter>
    </ErrorBoundary>
  );
}

export default App;
